import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'

import colorNames from '../../design/color-names'

export const DATALIST_VARIANT_ONWHITE = 'onwhite'
export const DATALIST_VARIANT_ONGREY = 'ongrey'

const borderColor = ({ $variant }) =>
  $variant === DATALIST_VARIANT_ONWHITE
    ? colorNames.athensGray
    : colorNames.geyser

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ $padding }) => ($padding !== undefined ? `padding: ${$padding};` : '')}
  color: var(--boulder);
  border-bottom: 1px solid ${borderColor};
  :first-of-type {
    border-top: 2px solid ${borderColor};
  }
  :last-of-type {
    border-bottom: 2px solid ${borderColor};
  }
`

export const DataListRow = ({
  className,
  children,
  'data-mu-test': dataAttributeTest,
  padding,
  variant
}) => {
  return (
    <Row
      className={className}
      data-mu-test={dataAttributeTest}
      $padding={padding}
      $variant={variant}
    >
      {children}
    </Row>
  )
}

DataListRow.defaultProps = {
  padding: '20px 0',
  variant: DATALIST_VARIANT_ONWHITE
}

DataListRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  padding: PropTypes.string,
  variant: PropTypes.oneOf([DATALIST_VARIANT_ONWHITE, DATALIST_VARIANT_ONGREY])
}
